import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocationSearchingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"location_searching"}/>
}
